module.exports = __webpack_public_path__ + "img/ring_g_c_null_1@3x.14c31dcc.png";